import { render, staticRenderFns } from "./CreateWIPackageModal.vue?vue&type=template&id=75b87159&scoped=true"
import script from "./CreateWIPackageModal.vue?vue&type=script&lang=js"
export * from "./CreateWIPackageModal.vue?vue&type=script&lang=js"
import style0 from "./CreateWIPackageModal.vue?vue&type=style&index=0&id=75b87159&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b87159",
  null
  
)

export default component.exports